<template>
  <div v-if="bestSellers">
    <v-container>
      <h2 class="text-h5 secondary--text font-weight-bold mb-7">{{ $t('label.topPick') }}</h2>
      <Carousel :banners="banners" rounded />
    </v-container>
    <Spacer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Carousel from '@/components/Carousel.vue'
import Spacer from '@/components/Spacer.vue'

export default {
  components: { Carousel, Spacer },

  computed: {
    ...mapGetters('page', ['bestSellers']),
    banners() {
      return this.bestSellers.map((item) => {
        return {
          image_desktop: item.image_desktop,
          redirect: { name: this.$constants.ROUTE_NAME.PRODUCT_BEST_SELLER, params: { topPickImageId: item.slider_image_id } }
        }
      })
    }
  }
}
</script>
